var moduleMap = {
	"./Sidebar": () => {
		return Promise.all([__webpack_require__.e(670), __webpack_require__.e(656), __webpack_require__.e(212), __webpack_require__.e(88), __webpack_require__.e(824)]).then(() => (() => ((__webpack_require__(5439)))));
	},
	"./Unauthorised": () => {
		return Promise.all([__webpack_require__.e(670), __webpack_require__.e(88), __webpack_require__.e(552)]).then(() => (() => ((__webpack_require__(2171)))));
	},
	"./Profile": () => {
		return Promise.all([__webpack_require__.e(670), __webpack_require__.e(656), __webpack_require__.e(88), __webpack_require__.e(834)]).then(() => (() => ((__webpack_require__(7453)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});